import {css} from 'styled-components';

export default css`
  width: 100%;
  height: 100%;
  border: 0;
`
